import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'
import { usePayrollStore } from '@/store/payroll-data'

const http = new HttpService()

export interface Direction {
  id?: string
  name: string
  code: string
  companyId: string
}

export async function getDirections(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = []
  if (search) {
    where.push(`CONCAT(name,code) ILIKE '%${search}%'`)
  }
  if (usePayrollStore().payroll?.company?.id) {
    where.push(`company_id = '${usePayrollStore().payroll?.company?.id ?? ''}'`)
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS NUMERIC) ELSE NULL END), code"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_directions'],
    fields: ['id', 'code', 'name', 'is_inactive', 'updated_at'],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response
}

export async function getDirection(id: string): Promise<Direction> {
  const data = await getData<any>({
    tables: ['pg_directions'],
    fields: [
      'directions.id',
      'directions.code',
      'directions.name',
      'directions.is_inactive',
      'directions.company_id as companyId',
      'countries.iso_code as isoCode',
      'directions.custom_fields as custom'
    ],
    where: [`directions.id = '${id}'`],
    join: [
      'INNER JOIN companies ON directions.company_id = companies.id',
      'INNER JOIN countries ON companies.country_id = countries.id'
    ],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createDirection(data: Direction): Promise<boolean> {
  const response: any = await http.post('payroll/directions', {
    name: data.name,
    code: data.code,
    companyId: data.companyId,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateDirection(
  data: Direction,
  id: string
): Promise<boolean> {
  const response: any = await http.put('payroll/directions/' + id, {
    name: data.name,
    code: data.code,
    companyId: data.companyId,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteDirection(id: string): Promise<boolean> {
  const response: any = await http.delete('payroll/directions/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function stateDirection(
  id: string,
  enable: boolean
): Promise<boolean> {
  const response: any = await http.put(`payroll/directions/${id}/enable`, {
    enable
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
